export const IconPause = ({size = 8}: { size?: number }) => {
    return <svg width={size} viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M0.666992 12.9326V0.932617H2.00033V12.9326H0.666992ZM6.00033 12.9326V0.932617H7.33366V12.9326H6.00033Z"
              fill="currentColor"/>
    </svg>

}
